export function buildConsultaWhois(nombreDominio, captchaResponse, wcv) {
    return {
        dominio: {
            nombre: nombreDominio
        },
        captchaResponse: captchaResponse,
        wcv: wcv
    }
}

export function buildConsultaWhoisResponse(nombreDominio, responseConsultaWhois) {
    return {
        dominio: nombreDominio,
        esRespOK: responseConsultaWhois.respuestaOK,
        respCodigo: responseConsultaWhois.codigo,
        respMensaje: responseConsultaWhois.mensaje,
        titular: responseConsultaWhois.titular,
        administrador: responseConsultaWhois.administrador,
        tecnico: responseConsultaWhois.tecnico,
        financiero: responseConsultaWhois.financiero,
        nameServers: responseConsultaWhois.nameServers,
        datosDOminio: responseConsultaWhois.datosDOminio,
        estado: responseConsultaWhois.estado,
        fechaAlta: responseConsultaWhois.fechaAlta
    }
}